import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiUrl, brands } from "../../config/config";
import ProductGridSkeleton from "./ProductGridSkeleton";

const ProductGrid = ({ categoryId, categoryName, limit = 6 }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const formattedName = categoryName
    ? categoryName.replace(/-/g, " ")
    : "Products";

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      let url = "";
      let applyLimit = true;

      if (categoryId === "all") {
        url = `${apiUrl}/api/${brands}/products`;
      } else if (categoryId === "allproducts") {
        url = `${apiUrl}/api/${brands}/products`;
        applyLimit = false;
      } else {
        url = `${apiUrl}/api/${brands}/products/category/${categoryId}`;
      }

      try {
        const res = await fetch(url);
        const data = await res.json();

        let productsList = [];

        if (Array.isArray(data)) {
          productsList = data;
        } else if (data.data && Array.isArray(data.data)) {
          productsList = data.data;
        }

        if (applyLimit) {
          productsList = productsList.slice(0, limit);
        }

        setProducts(productsList);
      } catch (err) {
        console.error("Product fetch error:", err);
        setProducts([]);
      }

      setLoading(false);
    };

    fetchProducts();
  }, [categoryId, limit]);

  if (loading) {
    return <ProductGridSkeleton count={limit} />;
  }

  if (products.length === 0) {
    return (
      <p className="py-12 text-center text-[15px] font-medium text-[#415164] sm:py-14">
        No products found.
      </p>
    );
  }

  return (
    <div className="w-full bg-white py-10 sm:py-12 lg:py-14">
      <div className="mx-auto w-full max-w-[1080px] px-4 sm:px-6 lg:px-8">
        <div className="mb-8 text-center sm:mb-10">
          <h2 className="text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
            {formattedName}
          </h2>

          <div className="mx-auto mt-6 h-px w-full max-w-[620px] bg-[#9ca3af]"></div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3 lg:gap-6">
          {products.map((item) => (
            <Link
              key={item.id}
              to={`/product/${
                item.category?.category_name?.replace(/\s+/g, "-") ||
                "category"
              }/${item.category_id}/${item.name?.replace(/\s+/g, "-")}/${
                item.id
              }`}
              className="group mx-auto block h-full w-full max-w-[280px] overflow-hidden rounded-[15px] border border-[#d9d9d9] bg-[#f3f3f3] px-3 pb-4 pt-3 text-center shadow-[0_4px_16px_rgba(0,0,0,0.16)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_26px_rgba(0,0,0,0.22)] sm:max-w-[290px] sm:px-4 sm:pb-5 sm:pt-4"
            >
              <div className="mx-auto flex h-[118px] w-full items-center justify-center overflow-hidden rounded-[12px] bg-transparent sm:h-[180px] lg:h-[195px]">
                <img
                  src={`${apiUrl}/storage/${item.image}`}
                  alt={item.name}
                  className="max-h-full max-w-full object-contain transition-transform duration-500 ease-out group-hover:scale-105"
                />
              </div>

              <h3 className="mt-4 line-clamp-2 min-h-[38px] text-center text-[13px] font-extrabold leading-[19px] text-black sm:min-h-[44px] sm:text-[16px] sm:leading-[22px] lg:text-[17px]">
                {item.name}
              </h3>

              <p className="mx-auto mt-2 text-center text-[12px] font-medium leading-[20px] text-[#111827] sm:text-[14px] sm:leading-[24px]">
                As low as ${item.discountedPrice}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductGrid;